<template>
  <div>
    <div class="mt-2">
      <div v-for="(template, index) in stopList" :key="index">
        <label class="text-field-label">{{ labelForStop(index) }}</label>
        <div class="stop-template">
          <div class="stop-template--input">
            <v-autocomplete
              class="mt-2"
              v-model="stopList[index]"
              :items="stops"
              :loading="fetchingStops"
              filled
              item-text="name"
              item-value="id"
              @change="updateStop(index, $event)"
              :error-messages="index === 0 ? errorMessage : ''"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="normal"
                  @click="getAllStops()"
                  :loading="fetchingStops"
                  icon
                >
                  <v-icon>
                    {{ icons.refresh }}
                  </v-icon>
                </v-btn>
              </template>
            </v-autocomplete>
          </div>
          <v-btn
            class="ml-5 mt-4"
            color="error"
            fab
            dark
            small
            v-if="index !== 0"
            @click="removeStop(index)"
          >
            <v-icon small>{{ icons.delete }}</v-icon>
          </v-btn>
        </div>
      </div>
      <v-btn
        text
        class="text-capitalize font-weight-bold text-primary"
        @click="addStop"
      >
        <v-icon>{{ icons.plusCircle }}</v-icon
        >Add Stop
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mdiTrashCanOutline, mdiPlusCircleOutline, mdiRefresh } from '@mdi/js'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    stopList: {
      type: Array
    },

    errorMessage: {
      type: Array
    }
  },

  data() {
    return {
      icons: {
        delete: mdiTrashCanOutline,
        plusCircle: mdiPlusCircleOutline,
        refresh: mdiRefresh
      }
    }
  },

  computed: {
    ...mapState({
      stops: state => state.stop.list,
      fetchingStops: state => state.stop.fetchingList
    })
  },

  methods: {
    ...mapActions({
      getAllStops: 'stop/getAllStops'
    }),

    addStop() {
      this.$emit('add')
    },

    removeStop(index) {
      this.$emit('remove', index)
    },

    updateStop(index, value) {
      this.$emit('update', {
        id: index,
        value: value
      })
    },

    labelForStop(index) {
      if (index === 0) {
        return 'Origin'
      }

      if (index === this.stopList.length - 1) {
        return 'Destination'
      }

      return `Stop ${index}`
    }
  }
}
</script>

<style lang="scss" scoped>
.stop-template {
  display: flex;
  flex-direction: row;

  &--input {
    width: 430px;
  }
}
</style>
